import { Shield, Github, Linkedin, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';

const footerLinks = {
  Platform: [
    { label: 'Human Identities', href: '#' },
    { label: 'Non-Human Identities', href: '#' },
    { label: 'AI Agent Management', href: '#' },
    { label: 'Identity Analytics', href: '#' },
    { label: 'Threat Detection', href: '#' },
  ],
  Solutions: [
    { label: 'Enterprise', href: '#' },
    { label: 'Financial Services', href: '#' },
    { label: 'Healthcare', href: '#' },
    { label: 'Government', href: '#' },
    { label: 'Technology', href: '#' },
  ],
  Resources: [
    { label: 'Documentation', href: '#' },
    { label: 'API Reference', href: '#' },
    { label: 'Blog', href: '#' },
    { label: 'Case Studies', href: '#' },
    { label: 'Community', href: '#' },
  ],
  Company: [
    { label: 'About', href: '#' },
    { label: 'Careers', href: '#' },
    { label: 'Contact', href: '#' },
    { label: 'Partners', href: '#' },
    { label: 'Trust Center', href: '#' },
  ],
};

export function Footer() {
  return (
    <footer className="border-t border-dark-800/60 bg-dark-950">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        {/* Main footer */}
        <div className="py-16 grid grid-cols-2 md:grid-cols-6 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <Shield className="h-8 w-8 text-cyber-400" />
              <span className="text-xl font-bold text-white">
                Identity<span className="text-cyber-400">Central</span>
              </span>
            </Link>
            <p className="text-sm text-dark-400 mb-6 leading-relaxed max-w-xs">
              The unified identity intelligence platform for securing humans, machines, and AI agents.
            </p>
            <div className="flex items-center gap-2">
              <a href="#" className="p-2.5 text-dark-500 hover:text-cyber-400 transition-colors rounded-lg hover:bg-white/5">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="p-2.5 text-dark-500 hover:text-cyber-400 transition-colors rounded-lg hover:bg-white/5">
                <Github className="h-5 w-5" />
              </a>
              <a href="#" className="p-2.5 text-dark-500 hover:text-cyber-400 transition-colors rounded-lg hover:bg-white/5">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-sm font-semibold text-white mb-4 tracking-wide">{title}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-dark-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="py-8 border-t border-dark-800/60 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-dark-500">
            &copy; {new Date().getFullYear()} IdentityCentral. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-dark-500 hover:text-dark-300 transition-colors">Privacy Policy</a>
            <a href="#" className="text-sm text-dark-500 hover:text-dark-300 transition-colors">Terms of Service</a>
            <a href="#" className="text-sm text-dark-500 hover:text-dark-300 transition-colors">Security</a>
            <a href="#" className="text-sm text-dark-500 hover:text-dark-300 transition-colors">SOC 2</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
